export default __webpack_public_path__ + "static/media/github.9b2f8f6b.svg";